import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';

export function init(): FirebaseApp {
  const firebaseConfig = process.env.FIREBASE_CONFIG;
  if (!firebaseConfig) {
    throw new Error('FIREBASE_CONFIG environment variable is required');
  }

  try {
    const config = JSON.parse(firebaseConfig);
    return initializeApp(config);
  } catch (error) {
    console.error('Failed to parse FIREBASE_CONFIG:', error);
    throw new Error('Invalid FIREBASE_CONFIG format');
  }
}

export const useFirebaseAuth = (): Auth => getAuth();

export const useSignOut = () => {
  const auth = useFirebaseAuth();
  return () => auth.signOut();
};
